import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const bulkDeleteCycleCountRules = unaryRpc({
  name: "bulkDeleteCycleCountRules" as const,
  input: z.object({
    ruleIds: z.array(cycleCountRuleIdFormat.schema).min(1).max(100),
  }),
  output: z.object({ deletedCount: z.int() }),
});
